import React, { useState, useEffect } from "react";
import { getRequest } from "../../axiosRoutes/index";
import { CircularProgress, Grid, Paper, Typography, Box, useMediaQuery } from "@mui/material";
// import { BarChart } from "@mui/x-charts";
import SideNavBar from "../sidebar/SideNav";
import HrSideNavBar from "../sidebar/HrSideNavBar";
import admin from "../../images/adminDashboard.jpg";
import { useNavigate } from 'react-router-dom';

// const palette = ['gold', 'green',  "red"];

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [countEmployee, setCountEmployee] = useState(0);
  const [countClient, setCountClient] = useState(0);
  const [countProject, setCountProject] = useState(0);
  const [countInventory, setCountInventory] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  // const [fitnessAmounts, setFitnessAmounts] = useState({
  //   approved: 0,
  //   rejected: 0,
  //   pending: 0,
  // });
  // const [leaves, setLeaves] = useState({
  //   approved: 0,
  //   rejected: 0,
  //   pending: 0,
  // });
  // const [medicalAmounts, setMedicalAmounts] = useState({
  //   approved: 0,
  //   rejected: 0,
  //   pending: 0,
  // });
  // const [salaryAmounts, setSalaryAmounts] = useState({
  //   approved: 0,
  //   rejected: 0,
  //   pending: 0,
  // });
  const [loading, setLoading] = useState(true);
  const role = localStorage.getItem("role");

  const fetchItemCount = async (url, setCount, name) => {
    const access = localStorage.getItem("access");
    try {
      const response = await getRequest(url, {
        headers: { Authorization: `Bearer ${access}` },
      });
      setCount(response.totals[`total_${name}`]);
    } catch (error) {
      console.error(`Error Fetching ${url}:`, error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchAggregate = async () => {
  //   try {
  //     setLoading(true);
  //     const access = localStorage.getItem("access");
  //     const res = await getRequest("employee/aggregate?filter=fiscalYear", {
  //       headers: { Authorization: `Bearer ${access}` },
  //     });

  //     let overallSalary = { approved: 0, rejected: 0, pending: 0 };
  //     let overallFitness = { approved: 0, rejected: 0, pending: 0 };
  //     let overallMedical = { approved: 0, rejected: 0, pending: 0 };
  //     let overallLeaves = { approved: 0, rejected: 0, pending: 0 };

  //     const reduceTotals = (data, totalKey) => {
  //       return data.reduce((acc, item) => {
  //         if (item[totalKey]) {
  //           switch (item._id) {
  //             case "approved":
  //               acc.approved += item[totalKey];
  //               break;
  //             case "rejected":
  //               acc.rejected += item[totalKey];
  //               break;
  //             case "pending":
  //               acc.pending += item[totalKey];
  //               break;
  //             default:
  //               break;
  //           }
  //         }
  //         return acc;
  //       },
  //         { approved: 0, rejected: 0, pending: 0 });
  //     };

  //     res.forEach((agg) => {
  //       const salaryTotals = reduceTotals(agg.salaryData, "total_salary");
  //       overallSalary.approved += salaryTotals.approved;
  //       overallSalary.rejected += salaryTotals.rejected;
  //       overallSalary.pending += salaryTotals.pending;

  //       const fitnessTotals = reduceTotals(agg.fitnessData, "total_fitness");
  //       overallFitness.approved += fitnessTotals.approved;
  //       overallFitness.rejected += fitnessTotals.rejected;
  //       overallFitness.pending += fitnessTotals.pending;

  //       const medicalTotals = reduceTotals(agg.medicalData, "total_medical");
  //       overallMedical.approved += medicalTotals.approved;
  //       overallMedical.rejected += medicalTotals.rejected;
  //       overallMedical.pending += medicalTotals.pending;

  //       const leavesTotals = reduceTotals(agg.leavesData, "total_leaves");
  //       overallLeaves.approved += leavesTotals.approved;
  //       overallLeaves.rejected += leavesTotals.rejected;
  //       overallLeaves.pending += leavesTotals.pending;
  //     });

  //     setSalaryAmounts(overallSalary);
  //     setFitnessAmounts(overallFitness);
  //     setMedicalAmounts(overallMedical);
  //     setLeaves(overallLeaves);
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.message || error.message || "An error occurred";
  //     console.error(errorMessage);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchItemCount("employee", setCountEmployee, 'active_employee');
    fetchItemCount("client", setCountClient, 'clients');
    fetchItemCount("project", setCountProject, 'projects');
    fetchItemCount("admin/inventory", setCountInventory, 'Inventory_records');
    // fetchAggregate();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <div className="app-container" style={{ color: "#fff", display: "flex" }}>
      {role === "admin" && <SideNavBar />}
      {role === "hr" && <HrSideNavBar />}
      <div style={{ flex: 1, margin: `${isSmallScreen ? '2.2rem' : '0.5rem'} 0.5rem 0.5rem 0.5rem` }}>
        <Box sx={{ flexGrow: 1, padding: "20px", marginTop: { xs: 4, md: 0 } }}>
          <Grid container spacing={2} justifyContent="flex-start">
            {[
              { name: "Employees", count: countEmployee, path: "/employees" },
              { name: "Clients", count: countClient, path: "/clients", role: "hr" },
              { name: "Projects", count: countProject, path: "/projects", role: "hr" },
              { name: "Office Inventory", count: countInventory, path: "/inventory" },
            ]
              .filter((item) => !(role === "hr" && item.role))
              .map((item) => (
                <Grid item xs={6} sm={6} md={3} key={item.name}>
                  <Paper
                    elevation={4}
                    style={{
                      backgroundColor: "#000",
                      color: "#fff",
                      textAlign: "center",
                      padding: "50px 15px",
                      borderRadius: "10px",
                      border: "2px solid #FF5722",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate(item.path)}
                  >
                    <Typography variant="h5" fontWeight="bold" fontSize="16px">
                      {item.name}
                    </Typography>
                    <Typography variant="h6">{item.count}</Typography>
                  </Paper>
                </Grid>
              ))}
          </Grid>

          <Box
            style={{
              marginTop: "20px",
            }}
          >
            <img
              src={admin}
              alt="Admin Background"
              style={{ width: "100%", height: "auto", borderRadius: "10px" }}
            />
          </Box>

          {/* <Grid container spacing={2} justifyContent="flex-start" alignItems="center" mt={5} backgroundColor="#fff">
            <Grid item xs={12} md={6} lg={3} >
              <BarChart
                xAxis={[{ scaleType: 'band', data: ['Fitness Allowances'] }]}
                colors={palette}
                sx={{ px: 0 }}
                series={[
                  { label: "Pending", data: [fitnessAmounts.pending] },
                  { label: "Approved", data: [fitnessAmounts.approved] },
                  { label: "Rejected", data: [fitnessAmounts.rejected] },
                ]}
                width={380}
                height={350}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3} >
              <BarChart
                xAxis={[{ scaleType: 'band', data: ['Medical Allowances'] }]}
                colors={palette}
                sx={{ px: 0 }}
                series={[
                  { data: [medicalAmounts.pending] },
                  { data: [medicalAmounts.approved] },
                  { data: [medicalAmounts.rejected] },
                ]}
                width={380}
                height={350}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3} >
              <BarChart
                xAxis={[{ scaleType: 'band', data: ['Salaries'] }]}
                colors={palette}
                sx={{ py: 1 }}
                series={[
                  { data: [salaryAmounts.pending] },
                  { data: [salaryAmounts.approved] },
                  { data: [salaryAmounts.rejected] },
                ]}
                width={380}
                height={350}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3} >
              <BarChart
                xAxis={[{ scaleType: 'band', data: ['Leaves'] }]}
                colors={palette}
                sx={{ px: 0 }}
                series={[
                  { data: [leaves.pending] },
                  { data: [leaves.approved] },
                  { data: [leaves.rejected] },
                ]}
                width={380}
                height={350}
              />
            </Grid>
          </Grid> */}
        </Box>
      </div>
    </div>
  );
};

export default AdminDashboard;
